export var DATE_PICKER_ACTION_BAR_CLASS_PREFIX = 'DatePickerActionBar';